module.exports = __webpack_public_path__ + "img/46e75b7.svg";